"use strict";

import { BlocksEditor } from "./BlocksEditor";
//import BlocksUtility from "./BlocksUtility";
export default BlocksEditor;

// export {
//     BlocksEditor,
//     BlocksUtility
// }

// export const blocks = {
//     BlocksEditor: BlocksEditor,
//     BlocksUtility: BlocksUtility
// }

// export { default as BlocksEditor } from './BlocksEditor'
// export { default as BlocksUtility } from './BlocksUtility'
